module.exports = __webpack_public_path__ + "static/media/spond_logo_white.05f10d94.svg";